import { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { UserData, FunnelStats } from '../../types';
import { computeFunnel } from '../../lib/metrics';

const COLORS = ['#c7d2fe', '#a5b4fc', '#818cf8', '#6366f1', '#4f46e5', '#4338ca'];

interface ConversionFunnelProps {
  users: UserData[];
  funnelStats?: FunnelStats;
}

export function ConversionFunnel({ users, funnelStats }: ConversionFunnelProps) {
  const data = useMemo(() => computeFunnel(users, funnelStats), [users, funnelStats]);

  return (
    <div className="chart-card">
      <h3>Conversion Funnel</h3>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data} layout="vertical" margin={{ left: 20, right: 40 }}>
          <XAxis type="number" fontSize={11} tick={{ fill: '#6b7280' }} />
          <YAxis type="category" dataKey="stage" fontSize={12} tick={{ fill: '#374151' }} width={90} />
          <Tooltip formatter={(value: number) => [`${value}`, 'Users']} />
          <Bar dataKey="count" radius={[0, 4, 4, 0]}>
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
            <LabelList dataKey="pct" position="right" formatter={(v: number) => `${v}%`} fontSize={11} fill="#6b7280" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
